import { render } from "./k-fileupload.vue?vue&type=template&id=636cb548&scoped=true"
import script from "./k-fileupload.vue?vue&type=script&lang=js"
export * from "./k-fileupload.vue?vue&type=script&lang=js"

import "./k-fileupload.vue?vue&type=style&index=0&id=636cb548&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636cb548"]])

export default __exports__